import React from 'react';
import styled, { withTheme } from 'styled-components';
import { TopNavBar, Screen, BottomTabBar } from '../components';

const Content = styled.div`
  display: flex;
  flex: 1;
  width: 100%;
  background: ${props => props.theme.fav.bg};
`;

const Calculator = ({ theme }) => (
  <Screen theme={theme} title="Calculator">
    <TopNavBar title="Calculator" left="ios-grid-outline" right="ios-add" rightSize="32px" />
    <Content />
    <BottomTabBar selected="calculator" />
  </Screen>
);

export default withTheme(Calculator);



// WEBPACK FOOTER //
// ./src/screens/Calculator.js